const CacheImages = [
  // Logo
  require('@/assets/img/logo/nina_2025.svg'),
  require('@/assets/img/logo/nina_2025.jpg'),
  require('@/assets/img/logo/sdi-logo-inline.svg'),
  require('@/assets/img/logo/sdi-logo.svg'),
  // Default Image
  require('@/assets/img/default/user-default.png'),
  require('@/assets/img/default/image-default.png'),
  // Icons
  require('@/assets/img/icons/menu/business-tracker-active.svg'),
  require('@/assets/img/icons/menu/business-tracker.svg'),
  require('@/assets/img/icons/menu/calendar-active.svg'),
  require('@/assets/img/icons/menu/calendar.svg'),
  require('@/assets/img/icons/menu/create-sales-order-active.svg'),
  require('@/assets/img/icons/menu/create-sales-order.svg'),
  require('@/assets/img/icons/menu/customer-active.svg'),
  require('@/assets/img/icons/menu/customer.svg'),
  require('@/assets/img/icons/menu/customer-registration-active.svg'),
  require('@/assets/img/icons/menu/customer-registration.svg'),
  require('@/assets/img/icons/menu/home-active.svg'),
  require('@/assets/img/icons/menu/home.svg'),
  require('@/assets/img/icons/menu/loyalty-point-active.svg'),
  require('@/assets/img/icons/menu/loyalty-point.svg'),
  require('@/assets/img/icons/menu/loyalty-point-setup-active.svg'),
  require('@/assets/img/icons/menu/loyalty-point-setup.svg'),
  require('@/assets/img/icons/menu/product-catalog-active.svg'),
  require('@/assets/img/icons/menu/product-catalog.svg'),
  require('@/assets/img/icons/menu/sales-activity-active.svg'),
  require('@/assets/img/icons/menu/sales-activity.svg'),
  require('@/assets/img/icons/menu/sales-order-active.svg'),
  require('@/assets/img/icons/menu/sales-order.svg'),
  require('@/assets/img/icons/menu/sales-team-active.svg'),
  require('@/assets/img/icons/menu/sales-team.svg'),
  require('@/assets/img/icons/menu/stock-tracker-active.svg'),
  require('@/assets/img/icons/menu/stock-tracker.svg'),
  require('@/assets/img/icons/menu/transaction-active.svg'),
  require('@/assets/img/icons/menu/transaction.svg'),
  require('@/assets/img/icons/notification/notification-approve.svg'),
  require('@/assets/img/icons/notification/notification-reject.svg'),
  require('@/assets/img/icons/close-grey.svg'),
  require('@/assets/img/icons/arrow-down-grey.svg'),
  require('@/assets/img/icons/arrow-left-double-grey.svg'),
  require('@/assets/img/icons/arrow-left-grey.svg'),
  require('@/assets/img/icons/arrow-right-double-grey.svg'),
  require('@/assets/img/icons/arrow-right-grey.svg'),
  require('@/assets/img/icons/check-circle-blue.svg'),
  require('@/assets/img/icons/trash-grey.svg'),
  require('@/assets/img/icons/delete.svg'),
  require('@/assets/img/icons/search.svg'),
  require('@/assets/img/icons/search-white.svg'),
  require('@/assets/img/icons/setting.svg'),
  require('@/assets/img/icons/schedule.svg'),
  require('@/assets/img/icons/plus-upload.svg'),
  require('@/assets/img/icons/plus-grey.svg'),
  require('@/assets/img/icons/pin-address.svg'),
  require('@/assets/img/icons/notification.svg'),
  require('@/assets/img/icons/no-product.svg'),
  require('@/assets/img/icons/more-white.svg'),
  require('@/assets/img/icons/more-vertical-white.svg'),
  require('@/assets/img/icons/minus-grey.svg'),
  require('@/assets/img/icons/logout.svg'),
  require('@/assets/img/icons/hamburger.svg'),
  require('@/assets/img/icons/filter-white.svg'),
  require('@/assets/img/icons/edit-white.svg'),
  require('@/assets/img/icons/edit-square-white.svg'),
  require('@/assets/img/icons/edit-blue.svg'),
  require('@/assets/img/icons/close-circle-grey.svg'),
  require('@/assets/img/icons/menu/inventory-list.svg'),
  require('@/assets/img/icons/menu/inventory-summary.svg'),
  require('@/assets/img/icons/menu/sales-order-spreading.svg'),
  require('@/assets/img/icons/menu/inventory-list-active.svg'),
  require('@/assets/img/icons/menu/inventory-summary-active.svg'),
  require('@/assets/img/icons/menu/sales-order-spreading-active.svg'),
];

export default CacheImages;
